import CreateBranchGroupDialog from './createBranchGroupDialog.container';

export default CreateBranchGroupDialog